import { render, staticRenderFns } from "./LogoSvg.vue?vue&type=template&id=54f8ef2c&"
import script from "./LogoSvg.vue?vue&type=script&lang=js&"
export * from "./LogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports